export const SET_CURRENT_IMAGE = "set_current_image";
export const SET_KYC_STEP = "set_kyc_step";
export const SET_CURRENT_TEXT = "set_current_text";